// extracted by mini-css-extract-plugin
module.exports = {"carouselnav":"carouselnav_carouselnav__4HJad","carouselnav-item":"carouselnav_carouselnav-item__0_lPZ","is-active":"carouselnav_is-active__VHicx"};